import { ErrorMessage, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { sourceOptions } from '../../../../common/utils/event_constants';
import { CUSTOM_MODAL_SEPARATOR, getSnippetModalOptions } from '../../ActionFormUtils';
import { MappingForm } from './MappingForm';

export const ReferenceDropdown = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [collection, setCollection] = useState('');
  const [source, setSource] = useState('');
  const [formPage, setFormPage] = useState('');
  const [pageContent, setPageContent] = useState('');
  const [mapping, setMapping] = useState([{ id: 0, key: '', value: '' }]);

  useEffect(() => {
    let sourceName = '';
    actionData.args.forEach((arg) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === arg.name;
      });
      if (dbParameters) {
        if (arg.name === 'collection') setCollection(dbParameters.value);
        if (arg.name === 'source') {
          sourceName = dbParameters.value;
          setSource(dbParameters.value);
        }
        if (arg.name === 'formPage') onPageChange('', dbParameters.value, sourceName);
        if (arg.name === 'mapping') setMapping(dbParameters.value);
      } else setSource('PAGE');
    });
  }, [actionData]);

  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const getModalListFromSnippets = () => {
    const { snippets } = events;
    let options = getSnippetModalOptions(snippets);
    return options;
  };

  const getSubPageListFromSnippets = () => {
    let options = [];
    const { snippets } = events;
    const subPageSnippet = snippets.filter((snippet) => snippet.snippetType === 'SUB_PAGE');
    subPageSnippet.forEach((snippet) => {
      options.push({
        value: snippet.uuid,
        label: snippet.name,
      });
    });

    return options;
  };

  const sourcePageOptions = () => {
    let options = [];
    switch (source) {
      case 'MODAL':
        options = getModalListFromSnippets();
        break;
      case 'SUB_PAGE':
        options = getSubPageListFromSnippets();
        break;
      default:
        options = events.pages.map((item) => ({
          value: item.uuid,
          label: item.name,
        }));
        break;
    }
    return options;
  };

  const createActionSettingsSchema = () => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      schema[args.name] = dbParameters ? dbParameters.value : '';
    });
    schema['source'] = schema['source'] ? schema['source'] : source;
    console.log('createActionSettingsSchema,', schema);
    return schema;
  };

  const getPageContent = (value, sourceName = '') => {
    const { pages, snippets } = events;
    value = value.includes(CUSTOM_MODAL_SEPARATOR) ? value.split(CUSTOM_MODAL_SEPARATOR)[1] : value;
    let page = '';
    sourceName = sourceName ? sourceName : source;
    if (['MODAL', 'SUB_PAGE'].includes(sourceName)) {
      page = snippets.find((snip) => snip.uuid === value);
    } else {
      page = pages.find((page) => page.uuid === value);
    }
    return page ? page.content : '';
  };

  const onPageChange = (name, value, sourceName = '') => {
    setFormPage(value);
    const pageContent = getPageContent(value, sourceName);
    setPageContent(pageContent);
  };

  const handleSubmit = (values) => {
    let parameters = [];
    const newMapping = mapping.filter(
      (row) => !['', undefined].includes(row.value) || typeof row.value !== 'undefined',
    );
    values = { ...values, mapping: newMapping };
    ['key', 'value', 'refField'].forEach((key) => {
      if (values[key]) delete values[key];
    });
    Object.keys(values).map((value) => {
      console.log('value', value);
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      console.log('action', action);
      parameters.push({
        name: value,
        value: values[value],
        type: action && action.type ? action.type : 'dropdown',
      });
    });
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema()}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
      }}
    >
      {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Collection"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select a Collection.'}
                >
                  <CustomSelect
                    name={'collection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={collection}
                    onChangeValue={(name, value) => setCollection(value)}
                  />
                  <ErrorMessage name={'collection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Source"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Source'}
                >
                  <CustomSelect
                    name={'source'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={sourceOptions}
                    value={source}
                    onChangeValue={(name, value) => setSource(value)}
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="From Page"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'From Page'}
                >
                  <CustomSelect
                    name={'formPage'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={sourcePageOptions()}
                    value={formPage}
                    onChangeValue={onPageChange}
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            {collection && formPage && (
              <div className="col-12 px-4">
                <MappingForm
                  mapping={mapping}
                  setMapping={setMapping}
                  collection={collection}
                  collections={events.collections}
                  pageContent={pageContent}
                />
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i>&nbsp;Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className="btn btn-theme-submit btn-sm">
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
